export type PickerOptions = {
  ignoreHost: HTMLElement;
  onPick: (el: Element) => void;
  onCancel: () => void;
  onHover: (el: Element | null, rect: DOMRect | null) => void;
};

export function startPicker(opts: PickerOptions) {
  let current: Element | null = null;

  const handleMove = (e: MouseEvent) => {
    const el = document.elementFromPoint(e.clientX, e.clientY);
    if (!el || opts.ignoreHost.contains(el) || el === document.documentElement || el === document.body) {
      if (current) {
        current = null;
        opts.onHover(null, null);
      }
      return;
    }
    if (el !== current) {
      current = el;
      opts.onHover(el, el.getBoundingClientRect());
    }
  };

  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const el = document.elementFromPoint(e.clientX, e.clientY);
    if (!el || opts.ignoreHost.contains(el)) return;
    cleanup();
    opts.onPick(el);
  };

  const handleKey = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      cleanup();
      opts.onCancel();
    }
  };

  const prevCursor = document.documentElement.style.cursor;
  document.documentElement.style.cursor = "crosshair";

  const cleanup = () => {
    document.removeEventListener("mousemove", handleMove, true);
    document.removeEventListener("click", handleClick, true);
    document.removeEventListener("keydown", handleKey, true);
    document.documentElement.style.cursor = prevCursor;
  };

  document.addEventListener("mousemove", handleMove, true);
  document.addEventListener("click", handleClick, true);
  document.addEventListener("keydown", handleKey, true);

  return cleanup;
}
